"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthDispatch = exports.useAuthState = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@xstate/react");

var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var authMachine = _AuthMachine.default.machine;
var StateContext = /*#__PURE__*/(0, _react.createContext)();
var DispatchContext = /*#__PURE__*/(0, _react.createContext)(function () {});
var Provider = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var children = _ref.children,
      _ref$apiBaseUrl = _ref.apiBaseUrl,
      apiBaseUrl = _ref$apiBaseUrl === void 0 ? "https://resource-platform-api.oneclass.com.tw" : _ref$apiBaseUrl,
      _ref$productApiUrl = _ref.productApiUrl,
      productApiUrl = _ref$productApiUrl === void 0 ? "https://resource-library-api-dev.oneclass.com.tw" : _ref$productApiUrl;

  var _useMachine = (0, _react2.useMachine)(authMachine, {
    context: {
      apiBaseUrl: apiBaseUrl,
      productApiUrl: productApiUrl
    }
  }),
      _useMachine2 = _slicedToArray(_useMachine, 2),
      state = _useMachine2[0],
      send = _useMachine2[1];

  console.log(state);
  return /*#__PURE__*/_react.default.createElement(StateContext.Provider, {
    value: state
  }, /*#__PURE__*/_react.default.createElement(DispatchContext.Provider, {
    value: send
  }, children));
});

var useAuthState = function useAuthState() {
  return (0, _react.useContext)(StateContext);
};

exports.useAuthState = useAuthState;

var useAuthDispatch = function useAuthDispatch() {
  return (0, _react.useContext)(DispatchContext);
}; // const useAuth = () => {
// 	const dispatch = useAuthDispatch();
// 	const logout = () => dispatch({ type: "" });
// 	// const event = useMemo(() => ({
// 	// 	logout,
// 	// }));
// 	return {
// 		logout,
// 	};
// };


exports.useAuthDispatch = useAuthDispatch;
var _default = Provider;
exports.default = _default;
Provider.propTypes = {
  children: _propTypes.default.node,
  apiBaseUrl: _propTypes.default.string,
  productApiUrl: _propTypes.default.string
};